import { render, staticRenderFns } from "./WordCard.vue?vue&type=template&id=aa77ef5a&"
import script from "./WordCard.vue?vue&type=script&lang=js&"
export * from "./WordCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports